import { useMutation, useQueryClient } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import {
  AiListeningBrandProfileApiService,
  AiListeningErrorEnvelope,
} from 'src/services/aiListeningApi/brandProfile'

interface RunVariables {
  profileId: string
  subjectId: string
}

interface UseRunAiListeningSiteAuditMutationParams {
  onError?: (error: AxiosError<AiListeningErrorEnvelope>) => void
}

export const useRunAiListeningSiteAuditMutation = ({
  onError,
}: UseRunAiListeningSiteAuditMutationParams = {}) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ profileId, subjectId }: RunVariables) =>
      AiListeningBrandProfileApiService.runSiteAudit(profileId, subjectId),
    onError,
    onSuccess: (data, { profileId, subjectId }) => {
      queryClient.setQueryData(
        [QueryKey.GET_AI_LISTENING_PROFILE_SITE_AUDIT, profileId, subjectId],
        data
      )
    },
  })
}
